<template>
    <div>
        <div class="row">
            <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="form-group">
                    <label for="exampleInputEmail1">First Name</label>
                    <input type="text" class="form-control" name="FirstName" placeholder="First Name" v-model="FirstName" id="FirstName">
                    <span class="error" v-if="errors.indexOf('InvalidFirstName')>-1">First Name is required. </span>
                </div>
            </div>
            <div class="col-md-6 col-sm-6 col-xs-12">
                <div class="form-group">
                    <label for="exampleInputEmail1">Last Name</label>
                    <input type="text" class="form-control" name="LastName" placeholder="Last Name" v-model="LastName" id="LastName">
                    <span class="error" v-if="errors.indexOf('InvalidLastName')>-1">Last Name is required. </span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 col-xs-12">
                <div class="form-group">
                    <label for="exampleInputEmail1">Email Address</label>
                    <input type="email" class="form-control" name="EmailAddress" placeholder="Email Address" v-model="EmailAddress" id="EmailAddress" />
                    <span class="error" v-if="errors.indexOf('InvalidEmailAddress')>-1">Email Address is required. </span>
                    <span class="error" v-if="errors.indexOf('InvalidEmailAddressFormat')>-1">Invalid Email Address. </span>
                </div>
            </div>
            <div class="col-md-12 col-xs-12">
                <div class="form-group">
                    <label for="exampleInputEmail1">Phone</label>
                    <input type="text" class="form-control" name="Phone" placeholder="Phone" v-model="Phone" id="Phone" />
                    <span class="error" v-if="errors.indexOf('InvalidPhone')>-1">Phone number is required. </span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <div class="form-group">
                    <label for="exampleInputEmail1">Search your address</label>
                    <AddressSearch v-on:AddressChanged="AddressChanged" :placeholder="'Search to pre-populate address information'" :SearchId="'NewPetOwnerForm'" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-12">
                <div class="form-group">
                    <label for="Address">Address</label>
                    <input type="text" class="form-control" name="Address" placeholder="Address" v-model="Address" id="Address" />
                    <span class="error" v-if="errors.indexOf('InvalidAddress')>-1">Address is required.</span>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group">
                    <label for="City">City</label>
                    <input type="text" class="form-control" name="City" placeholder="City" v-model="City" id="City" />
                    <span class="error" v-if="errors.indexOf('InvalidCity')>-1">City is required.</span>
                </div>
            </div>
            <div class="col-xs-12 col-sm-8 col-md-4">
                <div class="form-group">
                    <label for="State">State</label>
                    <select class="form-control" v-model="SelectedState">
                        <option :SelectedSpecies="true">-- Select --</option>
                        <option v-for="(stateName,counter) in states" v-bind:value="stateName" :key="counter">
                            {{stateName.Name}}
                        </option>
                    </select>
                    <span class="error" v-if="errors.indexOf('InvalidState')>-1">State is required.</span>
                </div>
            </div>
            <div class="col-xs-4 col-md-4">
                <div class="form-group">
                    <label for="Zip">Zip</label>
                    <input type="text" class="form-control" name="Zip" placeholder="Zip" v-model="Zip" id="Zip" />
                    <span class="error" v-if="errors.indexOf('InvalidZip')>-1">Zip is required.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AddressSearch from './ClientPracticeAddressSearch'
import AddressParser from '../api/AddressParser'
import { mapGetters } from 'vuex'

export default {
    name: "NewPetOwnerForm",
    components: { AddressSearch },
    data() {
        return {
            errors: []
        }
    },
    computed: {
        ...mapGetters({
            states: 'states',
        }),
        FirstName: {
            get() {
                return this.$store.state.PetOwnerDetails.FirstName
            },
            set(value) {
                this.$store.commit('UpdateFirstName', value)
            }
        },
        LastName: {
            get() {
                return this.$store.state.PetOwnerDetails.LastName
            },
            set(value) {
                this.$store.commit('UpdateLastName', value)
            }
        },
        EmailAddress: {
            get() {
                return this.$store.state.PetOwnerDetails.EmailAddress
            },
            set(value) {
                this.$store.commit('UpdateEmailAddress', value)
            }
        },
        Phone: {
            get() {
                return this.$store.state.PetOwnerDetails.Phone
            },
            set(value) {
                this.$store.commit('UpdatePhone', value)
            }
        },
        Address: {
            get() {
                return this.$store.state.PetOwnerDetails.Address
            },
            set(value) {
                this.$store.commit('UpdateAddress', value)
            }
        },
        City: {
            get() {
                return this.$store.state.PetOwnerDetails.City
            },
            set(value) {
                this.$store.commit('UpdateCity', value)
            }
        },
        SelectedState: {
            get() {
                return this.$store.state.PetOwnerDetails.State
            },
            set(value) {
                this.$store.commit('UpdateState', value)
            }
        },
        Zip: {
            get() {
                return this.$store.state.PetOwnerDetails.Zip
            },
            set(value) {
                this.$store.commit('UpdateZip', value)
            }
        },
    },
    methods: {
        AddressChanged(place) {
            if (place.geometry) {
                var address = AddressParser(place);
                this.Address = address.street_number + " " + address.route;
                this.Zip = address.postal_code;
                this.City = address.locality;
                if (address.administrative_area_level_1 != '') {
                    var selectedStates = this.states.filter(selectstate =>
                        selectstate.Code == address.administrative_area_level_1)
                    if (selectedStates.length > 0) {
                        this.$store.commit('UpdateState', selectedStates[0])
                    }
                }
            }
        },
        ValidateAll() {
            this.errors = [];
            if (!this.FirstName || this.FirstName == '') {
                this.errors.push("InvalidFirstName");
            }
            if (!this.LastName || this.LastName == '') {
                this.errors.push("InvalidLastName");
            }

            if (!this.EmailAddress || this.EmailAddress == '') {
                this.errors.push("InvalidEmailAddress");
            }

            if (this.EmailAddress && this.EmailAddress.indexOf("@") == -1) {
                this.errors.push("InvalidEmailAddressFormat");
            }

            if (!this.Phone || this.Phone == '') {
                this.errors.push("InvalidPhone");
            }

            if (!this.Address || this.Address == '') {
                this.errors.push("InvalidAddress");
            }

            if (!this.City || this.City == '') {
                this.errors.push("InvalidCity");
            }

            if (!this.Zip || this.Zip == '') {
                this.errors.push("InvalidZip");
            }

            if (!this.SelectedState || this.SelectedState == '-- Select --') {
                this.errors.push("InvalidState");
            }

            if (this.errors.length > 0) {
                return false;
            }
            else {
                return true;
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/NewPetOwnerForm.vue